import {
  PaletteColor,
  PaletteOptions,
} from "@material-ui/core/styles/createPalette";

import { Grid } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

interface StatusBadgeProps {
  status?: string;
  variableWidth?: boolean;
  marginLeft?: string;
}

const GrowthBadge = styled.div<StatusBadgeProps>`
  position: relative;
  text-align: center;
  ${({ variableWidth }) =>
    variableWidth ? "min-width: 3rem;" : "width: 3rem; flex-shrink: 0;"};
  ${({ marginLeft }) => marginLeft && `margin-left: ${marginLeft};`}
  font-size: 0.85em; // Relative to the parent font size
  height: 1.2rem;
  line-height: 1.2rem;
  overflow: hidden;
  ${({ theme, status }) => `
    color: ${
      status
        ? status === "disabled" || status === "noData"
          ? theme.palette.disabled.light
          : status === "borderline" || status === "success"
          ? theme.palette.success.main
          : (theme.palette[status as keyof PaletteOptions] as PaletteColor)
              ?.main
        : theme.palette.text.secondary
    };
  `}

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    border-radius: ${({ theme }) => 0.5 * theme.shape.borderRadius}px;
    opacity: 0.25;
    ${({ theme, status }) => `
      background-color: ${
        status
          ? status === "disabled" || status === "noData"
            ? theme.palette.disabled.light
            : status === "borderline" || status === "success"
            ? theme.palette.success.light
            : (theme.palette[status as keyof PaletteOptions] as PaletteColor)
                ?.light
          : theme.palette.text.disabled
      };
      ${
        status &&
        status === "borderline" &&
        `border: 1px ${theme.palette.error.light} solid;`
      }
    `}
  }

  & > * {
    position: relative;
    z-index: 2;
  }
`;

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  children,
  ...otherProps
}) => {
  return (
    <GrowthBadge {...otherProps}>
      <Grid container justifyContent="center" alignItems="center" wrap="nowrap">
        {children}
      </Grid>
    </GrowthBadge>
  );
};
